<template>
    <div class="page">
        <p>
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br /> {{ userStore.user.address }}
            <br /> {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
        </p>
        <p>
            {{ creditBureau.address_name }} <br />
            {{ address.street }} <br />
            {{ address.city }}, {{ address.state_abbreviation }}
            {{ address.zipcode }}
        </p>
        <p>
            {{ date }}
        </p>
        <p class="letter-content">
            This letter is to be taken as my formal complaint that you are reporting inaccurate credit information on my credit file.
        </p>
        <p class="letter-content">
            I am quite miffed that you have included the following information on my credit report:
        </p>

        <p v-for="creditor in reportStore.getSelectedAccounts(1, creditBureau.id)">
            <strong>
                Account Name: {{ creditor.furnisher_name }}
                <br/>
                <template v-if="creditor.reference_number">
                    Account Number: {{ creditor.reference_number }}<br/>
                </template>
                <template v-else>
                    Account Name: {{ creditor.account_number }}<br/>
                </template>

                <template v-if="creditor.reason">
                    <br />
                    Reason: {{ creditor.reason }}<br/>
                </template>
            </strong>
        </p>

        <p class="letter-content">
            These inaccurate items are not only embarrassing, they are preventing me from obtaining the
            credit I deserve. As you and I are both aware, there are laws that ensure that credit bureaus
            report only accurate credit information. 
        </p>
        <p class="letter-content">
            It is evident that the inclusion of this inaccurateinformation is a mistake on either your part or the reporting creditor’s part.
        </p>
        <p class="letter-content">
            It is with great concern that I insist you verify that this information is incorrect and delete it from
            my profile. Due to the damaging effects of such negative inaccurate information I must insist that
            this is done swiftly. 
        </p>
        <p>
            Regards
            <br />
            <br />
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br>
            {{ userStore.user.ssn }}
            <br>
            {{ userStore.user.dob }}
        </p>
        <div class="page-content">
            <h1 style="padding: 0rem; 3rem; text-align: center;">Enclosures</h1>
            <p style="padding-top:3rem; text-align: center;">
                <img v-if='userStore.user.ssn_image_url' v-bind:src='userStore.user.ssn_image_url' width='300' height='200' />
                <img v-if='userStore.user.identity_image_url' v-bind:src='userStore.user.identity_image_url' width='300' height='200' />
            </p>
            <p v-if='userStore.user.address_verify_image_url'>
                <img v-bind:src='userStore.user.address_verify_image_url' width='300' height='200' />
            </p>
        </div>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useUserStore } from '../../stores/UserStore.js'
    import { useReportStore } from '../../stores/ReportStore.js'
    import moment from 'moment';
    export default {
        props: {
            creditBureau: {
                type: [Array, Object]
            },
            originalDisputeDate: {
                type: String
            },
            dateAccountRemoved: {
                type: String
            },
        },
        setup(props) {
            const address = _.find(props.creditBureau.addresses, { 'id': props.creditBureau.selected_address });
            return {
                date: ref(moment().format('LL')),
                userStore: useUserStore(),
                reportStore: useReportStore(),
                _: _,
                moment:moment,
                address,
            };
        },
    };
</script>
